<template>
	<div class="bg-white rounded-xl mt-6 shadow divide-y divide-gray-200">
		<!-- list header-->
		<div class="rounded-t-xl text-gray-700 px-3 py-2 gap-x-3">
			<h3 class="text-xl font-medium">{{ matchTitle }}</h3>
			<!-- font-medium hover:bg-gray-100 rounded-lg text-gray-500
            active:bg-gray-150 focus:gray-400 focus:ring-2 ring-gray-500-->

			<div class="flex items-center">
				<ui-select
					v-model="sortOrder"
					:options="sortOrderOptions"
					:allow-empty="false"
					@change="page = 1"
					class="mt-1"
				/>

				<button
					v-on:click.stop="$emit('close')"
					class="hover:bg-gray-100 rounded-lg -mr-2 p-2 ml-auto font-semibold underline text-orange-500 text-lg whitespace-nowrap items-center"
				>
					<ui-icon class="h-5 w-5" name="x" stroke-width="2.5" />
				</button>
			</div>
		</div>

		<!-- list matching items -->
		<ul class="divide-y divide-gray-200">
			<li class v-for="match in currentPageMatches" :key="match.id">
				<match-details-short
					:match="match"
					:key="match.id"
					:offer="offer"
					:showQuality="false"
				/>
			</li>
		</ul>

		<!-- pagination -->
		<div class="px-3 py-3 flex items-center justify-end" v-if="numPages > 1">
			<span
				v-for="p in pageRange"
				:key="'page_' + p"
				v-on:click="page = p"
				:class="[
					'ml-3 relative inline-flex items-center px-3 py-1.5 border text-sm font-medium rounded-md cursor-pointer',
					p == page
						? 'bg-green-500 border-green-500 text-green-100'
						: 'text-gray-500 bg-white hover:bg-gray-50',
				]"
				>{{ p }}</span
			>
		</div>
	</div>
</template>

<script>
import MyLotsCardMatches from "./CardMatches.vue";
export default {
	mixins: [MyLotsCardMatches],
};
</script>
